import {Device} from "src/app/infrastructure/moovement-api/models/asset";

export function isTag(device: Device) {
  return isGpsTag(device) ||
    isNfcTag(device) ||
    isProximityTag(device) ||
    isGpsProximityAccelerometerTag(device);
}

export function isGpsTag(device: Device) {
  return device.typeId.startsWith("MOO-TAG-");
}

export function isNfcTag(device: Device) {
  return device.typeId.startsWith("MOO-NFC-TAG-");
}

export function isProximityTag(device: Device) {
  return device.typeId.startsWith("MOO-PRX-");
}

export function isGpsProximityAccelerometerTag(device: Device) {
  return device.typeId.startsWith("MOO-TAG2-");
}
